// a callback to call when finished
// props s3url to put to, local file path to get the file from..

// get content type from file
export function getContentTypeFromFile(localUrl) {
  const ext = fileName.substr(fileName.lastIndexOf('.') + 1);
  if (ext === 'mp3') {
    return 'audio/mpeg';
  }
  if (ext === 'm4a') {
    return 'application/octet-stream';
  }
  if (ext === 'jpg' || ext === 'jpeg') {
    return 'image/jpeg';
  }
  if (ext === 'png') {
    return 'image/png';
  }
}

export function uploadToS3(s3Url, mp3Data, contentType, uploadProgress) {
  const formData = new FormData();
  // formData.append('fname', fileName);
  formData.append('data', mp3Data);

  // var file = new File([mp3Data], fileName);
  console.log('entered indep , s3 url = ', s3Url, ' localUrl = ');

  return new Promise(
    // resolve on success, reject on error or non-200
    (resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', s3Url);
      xhr.setRequestHeader('x-amz-acl', 'public-read');
      xhr.setRequestHeader('Content-Type', contentType || 'audio/wav');
      // xhr.setRequestHeader('Content-Disposition', 'inline');
      xhr.onreadystatechange = (e) => {
        if (xhr.readyState !== 4) {
          // not comoleted
          return;
        }
        if (xhr.status === 200) {
          console.log('xhr success', xhr.responseText);
          resolve(200);
        } else {
          console.log('xhr error');
          reject();
        }
      };

      xhr.onload = function () {
        if (xhr.status === 200) {
          console.log('xhr success onload');
        } else {
          console.log('result err = ', xhr);
        }
      };

      // console.log('xhr.upload',xhr.upload);
      if (xhr.upload) {
        xhr.upload.onprogress = (event) => {
          // console.log('upload onprogress', event);
          if (event.lengthComputable) {
            uploadProgress && uploadProgress(event);
            // console.log('uploadProgress: ', event);
          }
        };
      }

      xhr.onerror = function (err) {
        console.log('err xhr', err);
        reject(err);
      };
      if (contentType) xhr.send(mp3Data);
      else xhr.send(formData);
    }
  );
}

// module.exports = IndependentUploadModule;
